/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-underscore-dangle */
import { Container, Box, Typography } from '@mui/material';

const Delivery = () => {
  return (
    <Container sx={{ px: 0, pb: 4 }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mt: 6, mb: 2 }}>
        Delivery
      </Typography>
      <Box
        sx={{
          px: 3,
          py: 3,
          backgroundColor: '#f5f5f5',
          borderRadius: 2,
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          maxWidth: 1000,
          mx: 'auto',
          color: '#444',
          fontSize: '0.95rem',
          lineHeight: 1.8,
          textAlign: 'left',
        }}
      >
        <Typography fontWeight="bold" gutterBottom>
          Filling your order
        </Typography>
        <Typography paragraph>
          Most orders are filled automatically. You should receive your serial
          number within 20 minutes. If you have any questions, just email{' '}
          <Box
            component="a"
            href="mailto:sales@digitalanarchy.com"
            sx={{ color: 'inherit', textDecoration: 'underline' }}
          >
            sales@digitalanarchy.com
          </Box>{' '}
          or call 415-287-6069.
        </Typography>

        <Typography fontWeight="bold" gutterBottom>
          Product delivery
        </Typography>
        <Typography paragraph>
          All products are delivered electronically. What does this mean? You
          will receive an email with a login code, your serial numbers, and
          links to get the product installers, support material, and sample
          files.
        </Typography>

        <Typography fontWeight="bold" gutterBottom>
          The emails you receive
        </Typography>
        <Typography paragraph>
          You will immediately receive an automated email that confirms your
          purchase. This is your sales receipt. It is NOT the email that
          contains your product downloads. A second email will usually arrive
          within 20 minutes after you purchase (it may be longer for some
          bundles). This email contains your product download information and
          serial number.
        </Typography>

        <Typography fontWeight="bold" gutterBottom>
          Physical Products
        </Typography>
        <Typography paragraph>
          We do not ship physical boxes. We are download only.
        </Typography>

        <Typography sx={{ mt: 2 }}>
          Thanks and enjoy! – The Anarchists
        </Typography>
      </Box>
    </Container>
  );
};

export default Delivery;
